/* Publish by EComposer at 2025-08-01 13:13:40*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-dybqowm2zdc"]=  window.__ectimmers["ecom-dybqowm2zdc"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),o=e.querySelector(".text-content.ecom-html");!o||(i&&i.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-dybqowm2zdc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dybqowm2zdc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9d7owtezcz4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9d7owtezcz4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g9chp4qcopm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g9chp4qcopm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8s1xp6qoqap').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8s1xp6qoqap', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bm7kpjmyzva').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bm7kpjmyzva', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-64nj7pmve7v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-64nj7pmve7v', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tfh447xzjio').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tfh447xzjio', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2iznqtm1gqz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2iznqtm1gqz', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-xmnw9ftgzfb"]=  window.__ectimmers["ecom-xmnw9ftgzfb"] || {};
if(!this.$el)return!1;const e=this.$el;this.settings.animation&&function(t){if(!e)return;const o=e.querySelector(".ecom__element--button");if(!o)return;let n=parseInt(t.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-xmnw9ftgzfb"]["g0avb18hd"] = setInterval(function(){o.classList.add("animated"),setTimeout(function(){o.classList.remove("animated")},s)},n)}(this);var i=e.querySelector(".ecom__element--button");this.isLive&&i&&i.dataset.ecTrackingId&&i.addEventListener("click",function(t){if(window.Shopify.analytics){t.preventDefault();let o=document.createElement("div");document.body.appendChild(o),o.click();let n=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const s=Object.assign({button_id:i.id,tracking_id:i.dataset.ecTrackingId},n);Shopify.analytics.publish("ec_custom_events",s),i.cloneNode(!0).click()}},{once:!0}),this.isLive&&i&&i.dataset.eventTrackingFb&&i.addEventListener("click",function(t){window.fbq&&window.fbq("track",`${i.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-xmnw9ftgzfb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xmnw9ftgzfb', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-02z9eym1cg4v"]=  window.__ectimmers["ecom-02z9eym1cg4v"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(n){const s=n.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-n.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function o(){let n=i.querySelector(".ecom-element.ecom-base-image"),s=i.closest(".core__row--columns");n&&(t(n)?(n.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(n.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){o()})

                    });
                    
                        document.querySelectorAll('.ecom-02z9eym1cg4v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-02z9eym1cg4v', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-27z5ssokid8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-27z5ssokid8', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}